<template>
    <div>
        <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="addEvent"
            style="margin-bottom: 10px"
        >
            新增配置
        </el-button>
        <filter-box
            channel="baidu"
            @reset="resetEvent"
            @search="searchEvent"
        ></filter-box>
        <div class="tableList">
            <!-- 表格部分 -->
            <el-table
                v-loading="tableLoading"
                :data="tableData"
                style="width: 100%"
                class="table-box"
                :header-cell-style="{
                    background: '#F5F5F5',
                    color: '#606266',
                }"
            >
                <el-table-column
                    prop="member_id"
                    label="会员ID"
                    width="150"
                >
                </el-table-column>
                <el-table-column
                    prop="detail_config"
                    label="详细配置"
                    min-width="300"
                >
                    <template slot-scope="{ row }">
                        <el-tooltip
                            popper-class="detailPopper"
                            effect="dark"
                            :content="row.detail_config"
                            placement="top"
                        >
                            <div
                                style="
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                "
                            >
                                <span style="white-space: nowrap">
                                    {{ row.detail_config }}
                                </span>
                            </div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="create_time"
                    label="创建日期"
                    width="180"
                >
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            style="padding: 0; color: #4d7efa"
                            class="f14h20w400"
                            @click="syncEvent(scope.row)"
                        >
                            同步更新
                        </el-button>
                        <el-button
                            type="text"
                            style="padding: 0; color: #4d7efa"
                            class="f14h20w400"
                            @click="delEvent(scope.row)"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="page-box">
                <el-pagination
                    @current-change="fetchList"
                    :current-page.sync="page"
                    :page-size.sync="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
        <baidu-dialog
            :visible.sync="dialogVisible"
            :actionType="dialogType"
            :configData="currentRow"
            @refresh="refreshList"
        ></baidu-dialog>
    </div>
</template>

<script>
import { MessageBox } from "element-ui";
import {
    getBaiDuConfigList,
    delBaiDuConfig,
    refreshBaiDuConfig,
} from "@/api/config";
import FilterBox from "./components/filterBox.vue";
import BaiduDialog from "./components/baiduDialog.vue";

export default {
    components: {
        FilterBox,
        BaiduDialog,
    },
    data() {
        return {
            page: 1,
            pageSize: 10,
            total: 0,
            tableLoading: false,
            tableData: [],
            searchParams: {
                member_id: "",
            },
            dialogVisible: false,
            dialogType: "add",
            currentRow: null,
        };
    },
    mounted() {
        this.fetchList();
    },
    methods: {
        async fetchList() {
            let { page, pageSize } = this;
            let { member_id } = this.searchParams;
            let params = {
                page,
                page_size: pageSize,
                member_id,
            };
            this.tableLoading = true;
            const res = await getBaiDuConfigList(params);
            this.tableLoading = false;
            if (res.code != 200) return;
            let { list, total } = res.data;
            this.tableData = list || [];
            this.total = parseInt(total);
        },
        addEvent() {
            this.dialogVisible = true;
            this.dialogType = "add";
        },
        resetEvent(params) {
            this.searchParams = params;
        },
        searchEvent(params) {
            this.page = 1;
            this.searchParams = params;
            this.fetchList();
        },
        async syncEvent({ id }) {
            this.tableLoading = true;
            const res = await refreshBaiDuConfig({
                id,
            }).catch((e) => {
                this.tableLoading = false;
            });
            if (res.code == 200) {
                this.fetchList();
            }
        },
        delEvent({ id }) {
            MessageBox.confirm("您确定要删除该百度配置？", "提示", {
                type: "warning",
            })
                .then(async () => {
                    this.tableLoading = true;
                    const res = await delBaiDuConfig({ id });
                    if (res.code == 200) {
                        this.$message.success("删除成功");
                        this.page = 1;
                        this.fetchList();
                    }
                })
                .catch((e) => {
                    this.tableLoading = false;
                    this.$message.error(e.msg);
                });
        },
        refreshList() {
            if (this.dialogType === "add") {
                this.page = 1;
                this.fetchList();
            } else {
                this.fetchList();
            }
        },
    },
};
</script>

<style lang="scss">
.detailPopper {
    max-width: 80%;
}
</style>
